import { createFileRoute } from "@tanstack/react-router";
import { DeskPage } from "../../../components/desk/desk-page";
import { deskSearch } from "../../../lib/desk/search";

/** Awarded events whose results or OVR suggestion moved since the desk settled them (`GET /medals/changed`). */
export const Route = createFileRoute("/_app/award/changed")({
	validateSearch: deskSearch,
	component: function ChangedDesk() {
		const search = Route.useSearch();
		return <DeskPage list="changed" search={search} />;
	},
});
